import { Plus, Zap } from "lucide-react";
import { PRODUCT_MAP, fmt } from "@/lib/load/products";
import { grossWeight } from "@/lib/load/weight";
import { OrderLine } from "@/components/load/OrderLine";

const lineName = (s) => (s.label ? `${s.label} (${PRODUCT_MAP[s.product].name})` : PRODUCT_MAP[s.product].name);

export const OrderCard = ({ lines, setAmount, onProduct, onRemove, onAdd, activeShell, onClear, onAllocate, shortfalls, group, setGroup, trailer, onFull, customerBar, t }) => {
  const total = lines.reduce((a, l) => a + l.gallons, 0);
  const gross = Math.round(grossWeight(trailer, lines));
  const over = gross - trailer.max_gross;
  return (
    <div className="card load-card" data-testid="order-card">
      <div className="section-title"><span className="load-step">1</span>{t("What did you order?")}</div>
      {customerBar}
      {lines.map((l) => <OrderLine key={l.key} line={l} t={t} onChange={(v) => setAmount(l.key, v)} onFull={() => onFull(l.key)}
        onProduct={onProduct && ((v) => onProduct(l.key, v))} onRemove={onRemove && lines.length > 1 ? () => onRemove(l.key) : null} />)}
      {onAdd && <button type="button" className="ghost-btn load-add" onClick={onAdd} data-testid="add-product-btn"><Plus size={18} />{t("Add product")}</button>}
      <div className="load-totals">
        <div>{t("Ordered")}: <b data-testid="total-ordered" className={total > activeShell ? "load-over" : ""}>{`${fmt(total)} gal`}</b> / <span data-testid="active-shell">{`${fmt(activeShell)} gal`}</span> {t("open space")}</div>
        <div>{t("Est. gross")}: <b data-testid="est-gross" className={over > 0 ? "load-over" : ""}>{`${fmt(gross)} lb`}</b> / {`${fmt(trailer.max_gross)} lb`} <small>({t("empty")} {`${fmt(trailer.tare_weight)} lb`})</small></div>
      </div>
      <button type="button" className={`ghost-btn load-toggle ${group ? "on" : ""}`} aria-pressed={group} onClick={() => setGroup(!group)} data-testid="group-products-toggle">
        <span className="load-switch" />{t("Keep same products together")}
      </button>
      <div className="load-actions">
        <button type="button" className="ghost-btn" onClick={onClear} data-testid="clear-order-btn">{t("Clear all")}</button>
        <button type="button" className="primary-btn" onClick={onAllocate} data-testid="auto-allocate-btn"><Zap size={18} />{t("Fill the pockets")}</button>
      </div>
      {shortfalls?.length > 0 && (
        <div className="scan-message tone-caution" data-testid="shortfall-alert">
          {t("Won't fit")}: {shortfalls.map((s) => `${fmt(s.gallons)} gal ${lineName(s)}`).join(", ")}.{" "}
          {trailer.diesel_in_double && shortfalls.some((x) => PRODUCT_MAP[x.product].group === "diesel")
            ? t("Diesel is limited to double-bulkhead pockets on this trailer.") : t("Unlock a dry pocket or lower the order.")}
        </div>
      )}
    </div>
  );
};
